import { Skeleton as MantineSkeleton } from "@mantine/core";

export const Skeleton = MantineSkeleton;
